import { SVGProps, Ref, forwardRef } from 'react';

export const IndexBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.75 12.11C.75 5.842 5.78.75 12 .75s11.25 5.093 11.25 11.36S18.22 23.468 12 23.468.75 18.376.75 12.109M12 2.25c-5.377 0-9.75 4.407-9.75 9.86s4.373 9.859 9.75 9.859c5.378 0 9.75-4.407 9.75-9.86S17.378 2.25 12 2.25"
                    fill="#0D8847"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 8.176c-.615 0-1.1.502-1.1 1.104s.485 1.104 1.1 1.104c.614 0 1.1-.502 1.1-1.104s-.486-1.104-1.1-1.104"
                    fill="#0D8847"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5 8.176c-.614 0-1.1.502-1.1 1.104s.486 1.104 1.1 1.104 1.1-.502 1.1-1.104-.485-1.104-1.1-1.104"
                    fill="#0D8847"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.021 14.265a.75.75 0 0 1 1.004.343 5.55 5.55 0 0 0 4.973 3.121 5.55 5.55 0 0 0 4.974-3.12.75.75 0 1 1 1.346.66 7.05 7.05 0 0 1-6.32 3.96 7.05 7.05 0 0 1-6.32-3.96.75.75 0 0 1 .343-1.004"
                    fill="#0D8847"
                />
            </g>
        </g>
    </svg>
));
IndexBrandSize24Glyph.displayName = 'IndexBrandSize24Glyph';
